import { createSlice } from "@reduxjs/toolkit";

const employeeSlice = createSlice({
  name: "employee",
  initialState: {
    employee: null,
  },

  reducers: {
    setEmployee: (state, action) => {
      state.employee = action.payload;
    },

    dropEmployee: (state, action) => {
      state.employee = null;
    },
  },
});

export default employeeSlice.reducer;
export const { setEmployee, dropEmployee } = employeeSlice.actions;
